<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Buyer Default Premium') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="premium-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="premium-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="col-md-12 footnote-textarea">
        <input-widget type="textarea" :model="model" attribute="buyer_invoice_footnote"/>
      </div>
      <div>
        <input-widget id="automatic-deposit-allocation-switch" is-switch class="d-inline-block" :model="model" attribute="automatic_deposit_allocation" type="checkbox"/>
        <b-popover target="automatic-deposit-allocation-switch" triggers="hover focus" placement="top">
          <span style="font-size: 1.3em">
            {{ $t("If functionality is available in case bidder has deposit invoice created and assigned for the specific sale, the deposit amount will be applied to the bidders invoice as a payment automatically, when generating of invoices for the sale.") }}
          </span>
        </b-popover>
      </div>
      <hr class="mt-0">
      <div v-if="selectedBranch">
        <premium-tiers :model="model" show-minimum-premium-field/>
      </div>
      <no-data-available :height="5" v-else/>
      <hr class="mt-0">
      <div class="col-xl-3 col-md-4">
        <input-widget :model="model" attribute="increment_calculation_source" value-field="value"
                      display-field="${item.key}" type="select2" :items="incrementCalculationSource"/>
      </div>
      <increment-tiers :model="model" attribute="default_auction_increments"/>
    </b-tab>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import NoDataAvailable from "../../../../../core/components/common/NoDataAvailable";
  import PremiumTiers from "../../../../../core/components/premium-tiers/PremiumTiers";
  import IncrementTiers from "../../../../../core/components/increment-tiers/IncrementTiers";
  import Spinner from "../../../../../core/components/common/Spinner";

  const {mapState} = createNamespacedHelpers('setup/branch');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "Premiums",
    components: {Spinner, IncrementTiers, PremiumTiers, NoDataAvailable, InputWidget},
    data() {
      return {};
    },
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['selectedBranch']),
      ...globalMapState(['taxStatuses', 'incrementCalculationSource']),
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footnote-textarea{
    /deep/ textarea{
      resize: none;
      height: 120px;
    }
  }
</style>
